export const services = [
  {
    id: "crm-erp",
    title: "CRM & ERP Systems",
    description: "Enterprise resource planning and customer relationship platforms engineered for scale. we architect systems that unify your operations, automate workflows, and deliver real-time business intelligence.",
    icon: "ri-database-2-line",
    features: ["Cloud-native architecture", "Real-time analytics dashboard", "Custom workflow automation", "Third-party API integrations"],
  },
  {
    id: "custom-software",
    title: "Custom Software",
    description: "Bespoke applications built from the ground up to solve your unique business challenges. Full-cycle development from architecture through deployment and ongoing optimization.",
    icon: "ri-code-s-slash-line",
    features: ["Microservices architecture", "Agile delivery methodology", "Cross-platform compatibility", "Legacy system migration"],
  },
  {
    id: "ai-solutions",
    title: "AI & Automation",
    description: "Production-grade artificial intelligence solutions including NLP, computer vision, and predictive analytics. We deploy models that create measurable operational efficiency gains.",
    icon: "ri-robot-2-line",
    features: ["Voice AI & conversational agents", "Document intelligence & OCR", "Predictive modeling & forecasting", "Intelligent process automation"],
  },
  {
    id: "web-dev",
    title: "Web Applications",
    description: "High-performance web platforms engineered for speed, conversion, and scalability. Modern frameworks, server-side rendering, and advanced SEO architecture.",
    icon: "ri-global-line",
    features: ["Next.js & React ecosystems", "Headless CMS architecture", "E-commerce & payment integration", "Core Web Vitals optimized"],
  },
  {
    id: "mobile-app",
    title: "Mobile Development",
    description: "Native iOS and Android applications with exceptional user experience. End-to-end development including UI/UX design, backend APIs, and App Store deployment.",
    icon: "ri-smartphone-line",
    features: ["React Native & Flutter", "Offline-first architecture", "Push notification systems", "CI/CD pipeline setup"],
  },
  {
    id: "cloud-devops",
    title: "Cloud & DevOps",
    description: "Cloud infrastructure design, migration, and managed services. We build resilient, auto-scaling architectures on AWS, GCP, and Azure with comprehensive CI/CD pipelines.",
    icon: "ri-cloud-line",
    features: ["Multi-cloud architecture", "Kubernetes orchestration", "Infrastructure as Code", "24/7 monitoring & alerting"],
  },
];

export const aiFeatures = [
  {
    id: "voice-ai",
    title: "Voice AI",
    description: "Conversational AI agents and speech recognition systems for customer service automation, IVR replacement, and voice-enabled applications with multi-language support.",
    icon: "ri-mic-line",
  },
  {
    id: "text-ai",
    title: "Text Intelligence",
    description: "Natural language processing pipelines for document classification, sentiment analysis, entity extraction, and automated content generation at enterprise scale.",
    icon: "ri-file-text-line",
  },
  {
    id: "predictive",
    title: "Predictive Analytics",
    description: "Machine learning models that forecast demand, detect anomalies, optimize pricing, and surface actionable insights from your operational data streams.",
    icon: "ri-line-chart-line",
  },
  {
    id: "computer-vision",
    title: "Computer Vision",
    description: "Image and video analysis systems for quality inspection, object detection, facial recognition, and automated visual monitoring in manufacturing and security.",
    icon: "ri-eye-line",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "Rajesh Verma",
    role: "CEO, NoidaTech Solutions",
    quote: "Emporris rebuilt our entire CRM from the ground up. The system now handles 200,000+ customer records with zero latency. Our sales cycle shortened by 40% within the first quarter after deployment.",
    rating: 5,
  },
  {
    id: "t2",
    name: "Priya Sharma",
    role: "COO, Bharat Logistics Group",
    quote: "Their AI automation platform reduced our manual document processing by 78%. What used to take 3 days now completes in under 4 hours. The ROI was evident within the first month.",
    rating: 5,
  },
  {
    id: "t3",
    name: "Amit Patel",
    role: "CTO, GreenLeaf Retail",
    quote: "We needed a mobile app that could handle 50K concurrent users during flash sales. Emporris delivered a Flutter app with 99.9% uptime. Flawless execution from architecture to launch.",
    rating: 5,
  },
  {
    id: "t4",
    name: "Sunita Gupta",
    role: "Director of Engineering, EduSmart",
    quote: "Their custom LMS platform now serves 80,000 students across 12 states. The microservices architecture they designed scales effortlessly during exam season traffic spikes.",
    rating: 5,
  },
  {
    id: "t5",
    name: "Vikram Singh",
    role: "VP Technology, MediCare Plus",
    quote: "Emporris engineered our healthcare ERP with full HIPAA and DPDP Act compliance. Their security architecture passed our third-party audit with zero findings. Exceptional attention to regulatory detail.",
    rating: 5,
  },
  {
    id: "t6",
    name: "Neha Kapoor",
    role: "Head of Digital, StyleHub India",
    quote: "The e-commerce platform they built for us handles 10,000+ daily orders seamlessly. Page load times under 1.2 seconds. Our conversion rate improved by 3.2x after the redesign.",
    rating: 5,
  },
];

export const whyChooseUs = [
  {
    id: "w1",
    title: "Enterprise Architecture",
    description: "Systems designed for millions of users, not hundreds. We engineer for scale from day one using battle-tested patterns.",
    icon: "ri-stack-line",
  },
  {
    id: "w2",
    title: "Full-Cycle Delivery",
    description: "From discovery and architecture through development, QA, deployment, and ongoing managed support — one team, end to end.",
    icon: "ri-loop-left-line",
  },
  {
    id: "w3",
    title: "Security-First Approach",
    description: "OWASP Top 10 hardened, SOC 2-aligned practices, encryption at rest and in transit. Security is embedded in our SDLC, not bolted on.",
    icon: "ri-shield-check-line",
  },
  {
    id: "w4",
    title: "Measurable Outcomes",
    description: "We define KPIs before writing a single line of code. Every engagement includes success metrics tied to your business objectives.",
    icon: "ri-bar-chart-2-line",
  },
  {
    id: "w5",
    title: "Rapid Time-to-Value",
    description: "Agile sprints with bi-weekly demos. Most projects ship an MVP within 6-8 weeks, not 6-8 months. Iterate fast, deliver faster.",
    icon: "ri-rocket-line",
  },
  {
    id: "w6",
    title: "Dedicated Engineering Teams",
    description: "You work directly with senior engineers who understand your domain. No junior-only teams, no bait-and-switch. Senior talent from day one.",
    icon: "ri-team-line",
  },
];

export const stats = [
  { value: "500+", label: "Projects Delivered" },
  { value: "150+", label: "Enterprise Clients" },
  { value: "12+", label: "Years Operating" },
  { value: "99.7%", label: "Uptime SLA" },
];